/**
 * The KEYLIV mark.
 *
 * A ribbon arch: two shoulders rising to a rounded apex, dropping to a point at
 * the centre — a roof and a heart read from the same outline, which is the idea
 * the brand board draws in three dimensions. Flattened to one path here because
 * this renders at 20–32px in a sidebar, where the rendered highlights of the
 * board artwork turn to mud and cost a raster download besides.
 *
 * Drawn with a stroke rather than a fill so the ribbon keeps an even weight
 * around the curve; a filled outline of the same shape thins at the shoulders
 * and thickens at the point.
 *
 * ⚠️ The gradient needs an id unique to the document. Two marks on one page —
 * the sidebar and the mobile top bar render together at every breakpoint — would
 * otherwise share one `<defs>` id, and the second would silently take the
 * first's gradient. `useId` is what keeps them independent.
 */
import { useId } from "react";

export default function Mark({ size = 28, className }: { size?: number; className?: string }) {
  const id = useId();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      className={className}
      role="img"
      aria-label="KEYLIV"
    >
      <defs>
        <linearGradient id={`keyliv-${id}`} x1="8" y1="52" x2="56" y2="12" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="var(--aqua)" />
          <stop offset="0.52" stopColor="var(--gold)" />
          <stop offset="1" stopColor="var(--coral)" />
        </linearGradient>
      </defs>
      <path
        d="M13 51V33a19 19 0 0 1 38 0v18L32 36Z"
        stroke={`url(#keyliv-${id})`}
        strokeWidth="8"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}
